import { createAction } from '@reduxjs/toolkit'

import { HealthStatusResponse } from '@/interfaces/health'

export const setHealthStatus = createAction<HealthStatusResponse>('auth/getCurrentUser')
